import api from "../../../utils/api";

//get inspection list
export const getInspections = async () => {
    const res = await api.get("/qa/inspections");
    return res.data;
};

//create inspection
export const createInspection = async (payload) => {
    const res = await api.post("/qa/inspections", payload);
    return res.data;
};

//get inspection by id
export const getInspectionById = async (id) => {
    const res = await api.get(`/qa/inspections/${id}`);
    return res.data;
};

export const getInspectionItems = async (id) => {
    const res = await api.get(`/qa/inspections/${id}/items`);
    return res.data;
};

//update inspection
export const updateInspection = async (id, payload) => {
    const res = await api.put(`/qa/inspections/${id}`, payload);
    return res.data;
};

//delete inspection
export const deleteInspection = async (id) => {
    const res = await api.delete(`/qa/inspections/${id}`);
    return res.data;
};

//add inspection result (item)
export const addInspectionResult = async (inspectionId, payload) => {
    const res = await api.post(`/qa/inspections/${inspectionId}/items`, payload);
    return res.data;
}

//update inspection result (item)
export const updateInspectionResult = async (itemId, payload) => {
    const res = await api.put(`/qa/inspection-items/${itemId}`, payload);
    return res.data;
}

//submit inspection
export const submitInspection = async (id) => {
    const res = await api.post(`/qa/inspections/${id}/submit`);
    return res.data;
}

//approve inspection
export const approveInspection = async (id) => {
    const res = await api.post(`/qa/inspections/${id}/approve`);
    return res.data;
}

//reject inspection
export const rejectInspection = async (id) => {
    const res = await api.post(`/qa/inspections/${id}/reject`);
    return res.data;
}

//upload attachment for inspection item
export const uploadInspectionAttachment = async (id, file) => {
    const formData = new FormData();
    formData.append("file", file);

    return await api.post(
        `/qa/inspections/${id}/upload`,
        formData,
        {
            transformRequest: (data, headers) => {
                delete headers["Content-Type"];
                return data;
            }
        }
    );
};

//delete inspection result (item)
export const deleteInspectionResult = async (itemId) => {
    const res = await api.delete(`/qa/inspection-items/${itemId}`);
    return res.data;
}